export default __webpack_public_path__ + "static/media/education-icon.565f375d.png";